export default {
  suite: {
    app: {
      list: "/suite/app/list",
      create: "/suite/app/create",
      update: "/suite/app/update",
    }
  },
  login: {
    backend: "/tic/login",
    phone: "/tic/phone",
    profile: "/maximo/user/profile",
  },
  servicenow: {
    incident: "/servicenow/incident",
    attachment: "/servicenow/attachment",
  },
  user: {
    machines: {
      list: "/maximo/user/machine/list",
      set: "/maximo/user/machine/set",
    },
    mates: "/maximo/user/mates",
    crews: {
      get_crew: "/maximo/crew/get_crew",
      get_crew_day: "/maximo/crew/get_crew_day",
      get_all_crews_siteid: "/maximo/crew/get_all_crews_siteid",
      get_all_crews_days: "/maximo/crew/get_all_crews_days",
      get_crew_days: "/maximo/crew/get_crew_days",
      day: {
        create: "/maximo/crew/day/create",
        get: "/maximo/crew/day/get",
        delete: "/maximo/crew/day/delete",
      },
      site: {
        get: "/maximo/crew/siteid/get",
        create: "/maximo/crew/siteid/create",
        delete: "/maximo/crew/siteid/delete",
      },
      day_labor_code: {
        get: "/maximo/crew/day_laborcode/get",
        create: "/maximo/crew/day_laborcode/create",
        modify: "/maximo/crew/day_laborcode/modify",
        delete: "/maximo/crew/day_laborcode/delete",
      },
      get: "/maximo/crew/get",
      create: "/maximo/crew/create",
      modify: "/maximo/crew/modify",
      deactivate: "/maximo/crew/deactivate",
      activate: "/maximo/crew/activate",
    },
    tdoc_tasks_subtasks: "/maximo/user/tdoc_tasks_subtasks"
  },
  master: {
    holidays: "/maximo/master/holidays",
    subcontractors: "/maximo/master/subcontractor",
    crews: {
      types: "/maximo/master/crew_types",
    },
    personGroupsAccess: "/maximo/user/persongroupaccess",
    workTypes: "/maximo/master/worktypes",
    locTypes: "/maximo/master/loctypes",
    technologies: "/maximo/master/tecnologies",
    logTypes: "/maximo/master/logtypes",
    reliabilitydegree: "/maximo/master/reliabilitydegree",
    tdoctasks: "/maximo/master/tdoctasks",
  },
  scheduling: {
    ots: {
      get_all_by_dates_locations:
        "/apintt/workorders/getWorkordersByDatesLocations",
      get_detail_by_wonum_location: "/apintt/workorders/getWorkOrder",
    },
    workorder: {
      get_OTs: "/maximo/workorder/get_OTs",
      get_planning: "/maximo/workorder/get_OTs_Planning",
      get_materials_planned_wo: "/maximo/workorder/get_OT_MaterialsPlanned",
      get_pendingworks_wo: "/maximo/workorder/get_OT_Pendingworks",
      get_pendingworks_location: "/maximo/workorder/get_OT_Pendingworks_Location",
      get_ot: "/maximo/workorder/get_OT",
      get_ot_workorderid: "/maximo/workorder/get_OT_workorderid",
      modify: "/maximo/workorder/modify",
      modify_extra: "/maximo/workorder/modify_extra",
      get_OTs_Hijas: "/maximo/workorder/get_OTs_Hijas",
      get_Posibles_OTs_Madre_Hija: "/maximo/workorder/get_Posibles_OTs_Madre_Hija",
      justification: {
        get_justifications_wo:
          "/maximo/workorder/justification/get_justifications_wo",
        create: "/maximo/workorder/justification/create",
        modify: "/maximo/workorder/justification/modify",
        delete: "/maximo/workorder/justification/delete",
      },
    },
    planlabor: {
      get_VerificationTDOC: "/maximo/planlabor/get_VerificationTDOC",
      get_TechnicianPlanlabor: "/maximo/planlabor/get_TechnicianPlanlabor",
      get_planlabor_planning: "/maximo/planlabor/get_planlabor_planning",
      get_planlabor_wo: "/maximo/planlabor/get_planlabor_wo",
      create: "/maximo/planlabor/create",
      modify: "/maximo/planlabor/modify",
      delete: "/maximo/planlabor/delete",
    },
  },
  databricks: {
    statement: "/repin/databricks/statement",
    statement_pending: "/repin/databricks/statement_pending",
    get_energia_diaria: "/repin/databricks/get_energia_diaria",
    get_statement_pending: "/repin/databricks/get_statement_pending",
    get_energia_ingreso_diaria_parque:
      "/repin/databricks/get_energia_ingreso_diaria_parque",
  },
  laboravailable: {
    get_mates_laboravailable:
      "/maximo/laboravailable/get_TechnicianLaboravailable",
    get_laboravailable_planning:
      "/maximo/laboravailable/get_laboravailable_planning",
    create: "/maximo/laboravailable/create",
    modify: "/maximo/laboravailable/modify",
    delete: "/maximo/laboravailable/delete",
  },
  filters: {
    get: "/favfilter/get",
    create: "/favfilter/create",
    update: "/favfilter/update",
    delete: "/favfilter/delete",
  },
};
